import { render, staticRenderFns } from "./replacementCodesTable.vue?vue&type=template&id=8c847efe&scoped=true&"
import script from "./replacementCodesTable.vue?vue&type=script&lang=js&"
export * from "./replacementCodesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c847efe",
  null
  
)

export default component.exports
import {QCard,QDialog,QCardSection,QInput,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QDialog,QCardSection,QInput,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
